import signupImage from "@assets/images/signup.png";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  Input,
  InputLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Cookies from "js-cookie";
// import Cookies from "js-cookie";
import React from "react";
import { Link } from "react-router-dom";

import OtpController from "../../controllers/OtpController";
const useStyles = makeStyles(
  theme => ({
    createAccount: {
      marginTop: 30
    },
    err_fields: {
      backgroundColor: "#393636",
      color: "#fff",
      left: 0,
      padding: "10px 20px",
      position: "absolute",
      right: 0,
      top: "-40px",
      width: "100%"
    },
    forgotPassword: {
      backgroundColor: "#011671",
      bottom: 0,
      color: "#fff",
      left: 0,
      outline: "none",
      padding: "5px 20px",
      position: "absolute",
      right: 0,
      textDecoration: "none",
      width: "100%;"
    },
    formControl: {
      margin: "-5px 0 0",
      width: "100%"
    },
    formHelper: {
      fontSize: "11px",
      margin: "3px 0 0",
      textAlign: "right"
    },
    formInput: {
      fontSize: "14px",
      margin: "0 !important",
      paddingTop: "18px"
    },
    formResendOtp: {
      backgroundColor: "transparent",
      border: 0,
      borderBottom: "1px solid #011671",
      color: "#011671",
      cursor: "pointer",
      displat: "inline",
      fontSize: "14px",
      marginLeft: "10px"
    },
    formSubmitBtn: {
      "& span": {
        color: "#fff"
      },
      backgroundColor: "#011671",
      borderRadius: 0,
      color: "#fff",
      float: "right",
      fontSize: "12px",
      marginLeft: "10px",
      padding: "2px 40px"
    },
    mainCard: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      paddingBottom: "50px",
      position: "relative"
    },
    root: {
      alignItems: "center",
      display: "flex",
      height: "100vH",
      justifyContent: "center",
      maxWidth: 800,
      padding: theme.spacing(6)
    },
    signupForm: {
      display: "flex"
    },
    signupImage: {
      position: "relative",
      top: 40,
      width: "100%"
    }
  }),
  { name: "OtpPage" }
);

export interface OTPVerifyFormData {
  pin: string;
}
export interface OtpCardProps {
  validations;
  handleResendOTP?(event);
  onSubmit?(event: OTPVerifyFormData);
}

const OtpPage: React.FC<OtpCardProps> = props => {
  // const { currentUser } = Cookies.get();
  const { handleResendOTP, validations, onSubmit } = props;
  const { usr, handleChange } = OtpController();
  const { currentUser } = Cookies.get();
  const classes = useStyles(props);
  const { err, err_msg } = validations;
  return (
    <Container className={classes.root}>
      <Card className={classes.mainCard}>
        <CardContent>
          {err_msg.length ? (
            <Box className={classes.err_fields}>
              {err_msg.length
                ? err_msg.map(err => err.message)
                : "Invalid Form! Please complete the fields"}
            </Box>
          ) : (
            ""
          )}
          <form
            onSubmit={e => {
              e.preventDefault();
              onSubmit(usr);
            }}
            noValidate
            autoComplete="off"
          >
            <Grid container>
              <Grid item xs={5}>
                <img className={classes.signupImage} src={signupImage} />
              </Grid>
              <Grid item xs={7}>
                <Grid container>
                  <Grid item xs={12}>
                    <strong>Create your Online Seller Account!</strong>
                  </Grid>
                  <Grid item xs={12}>
                    <p>
                      To verify your email, we've sent a One-time password (OTP)
                      to {JSON.parse(currentUser).email}
                    </p>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      error={err.pin ? true : false}
                      className={classes.formControl}
                      onChange={handleChange}
                    >
                      <InputLabel htmlFor="pin">Enter OTP: *</InputLabel>
                      <Input
                        className={classes.formInput}
                        name="pin"
                        id="pin"
                        value={usr.pin || ""}
                      />
                      <FormHelperText className={classes.formHelper}>
                        {err.pin ? err.pin : ""}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <Box className={classes.createAccount}>
                      <Button
                        type="submit"
                        className={classes.formSubmitBtn}
                        variant="contained"
                        color="primary"
                      >
                        Create Your Account
                      </Button>
                      <button
                        className={classes.formResendOtp}
                        type="button"
                        onClick={handleResendOTP}
                      >
                        Resend OTP
                      </button>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
          <Link className={classes.forgotPassword} to="/reset-password">
            Forgot your Password?
          </Link>
        </CardContent>
      </Card>
    </Container>
  );
};
OtpPage.displayName = "OtpPage";
export default OtpPage;
